import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Message } from 'element-ui';
import { advPlatformAll, getBindUserAdv, userBindAdv } from "@/api/advRelation";
export default {
  data: function data() {
    return {
      user_id: '',
      dialogFormVisible: false,
      Primitive: [],
      adv_platformtableData: [],
      adv_platformSelection: [],
      adv_placetableData: [],
      adv_placeSelection: []
    };
  },
  created: function created() {},
  methods: {
    handleSelectionChange: function handleSelectionChange(val, type) {
      this[type] = val;
    },
    toggleSelection: function toggleSelection(rows, type) {
      var _this = this;

      this.$refs[type].clearSelection();

      if (rows.length) {
        rows.forEach(function (row) {
          _this.$refs[type].toggleRowSelection(row);
        });
      }
    },
    init: function init(id) {
      var _this2 = this;

      this.dialogFormVisible = true;
      this.user_id = id;
      advPlatformAll().then( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(res) {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (res.status == 200) {
                    _this2.adv_platformtableData = res.data.adv_platform;
                    _this2.adv_placetableData = res.data.adv_place;
                    getBindUserAdv({
                      user_id: id
                    }).then(function (res) {
                      if (res.status == 200) {
                        var pList = res.data.user_adv_platform;
                        var pCList = res.data.user_adv_place;
                        _this2.adv_platformSelection = _this2.adv_platformtableData.filter(function (i) {
                          return pList.find(function (j) {
                            return j.adv_platform_id == i.id;
                          });
                        });
                        _this2.adv_placeSelection = _this2.adv_placetableData.filter(function (i) {
                          return pCList.find(function (j) {
                            return j.adv_place_id == i.id;
                          });
                        });

                        _this2.$nextTick(function () {
                          _this2.toggleSelection(_this2.adv_platformSelection, 'adv_platformTable');

                          _this2.toggleSelection(_this2.adv_placeSelection, 'adv_placeTable');
                        });
                      }
                    });
                  }

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    dataReset: function dataReset() {
      this.$refs.adv_platformTable.clearSelection();
      this.adv_platformtableData = [];
      this.adv_placetableData = [];
      this.dialogFormVisible = false;
    },
    dataFormSubmit: function dataFormSubmit(e) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                userBindAdv({
                  user_id: _this3.user_id,
                  adv_platform_id: _this3.adv_platformSelection.map(function (i) {
                    return i.id;
                  }).toString(),
                  adv_place_id: _this3.adv_placeSelection.map(function (i) {
                    return i.id;
                  }).toString()
                }).then(function (res) {
                  if (res.status == 200) {
                    Message.success('设置成功');

                    _this3.$store.dispatch('d2admin/serchSelect/setGame');

                    _this3.dataReset();
                  }
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};